<template>
  <cTable
    ref="table"
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
  >
    <template #TEST="{row}">
      <Select
        v-if="row"
        :placeholder="$t('select') + $t('currencyName')"
        @on-change="SelChange"
        v-model="row.currency_id"
        filterable
      >
        <Option
          v-for="(option, index) in options"
          :value="option.id"
          :key="index"
          :disabled="option.disabled"
          >{{ option.code }}</Option
        >
      </Select>
    </template>
  </cTable>
</template>

<script>
import {
  getCodRate,
  add,
  del,
  update,
  getDetails,
  getRateDetails,
  subRate,
  getCurrency
} from "@/api/finance/cod_rate";

import cTable from "@/base/common/index";
// import { getCurrency } from "@/api/finance/currency";
export default {
  name: "codRefundRate",
  components: {
    cTable
  },
  data() {
    let that = this;
    return {
      options: [],
      methods: {
        list: getCodRate,
        getDetails,
        del,
        add,
        update,
        getRateDetails,
        subRate,
        getCurrency
      },
      config: {
        height: 630
      },
      modals: {
        add: {
          methods: {
            ok({ row, close }) {
              let data = row;
              this.$page
                .handleRequestMethods(this.type, data, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "planName cannot be empty",
                  trigger: "blur"
                },
                {
                  max: 20,
                  message: "Please enter maximum length 20",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { remarks: 24 }],
          fields: [
            {
              name: () => this.$t("planName"),
              key: "name",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("planName");
              }
            },
            {
              name: () => this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4
              },
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              }
            }
          ]
        },
        rate: {
          slots: ["TEST"],
          methods: {
            ok({ list, close }) {
              let newList = list.filter(item => {
                if (item.currency_id) {
                  return item;
                }
              });
              let data = {
                currency: newList,
                id: this.params.id
              };
              this.$page.handleRequestMethods("subRate", data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            modalBind: {
              width: 800,
              draggable: true
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          footer: {
            show: this.$hasPermission(489)
          },
          table: {
            config: {
              height: 500
            },
            fields: [
              {
                type: "btns",
                width: 160,
                name: () => this.$t("operation"),
                fixed: "right",
                // width({ field }) {
                //   return field.list.length * 40 + 40;
                // },
                list: [
                  {
                    name: () => this.$t("add"),
                    type: "add",
                    fnName: "add",
                    bind: {
                      type: "warning"
                    },
                    icon: "md-add",
                    disabled({ rowIndex }) {
                      return rowIndex != 0;
                    }
                  },
                  {
                    name: () => this.$t("delete"),
                    type: "delete",
                    fnName: "delete",
                    icon: "md-trash",
                    disabled() {
                      return this.list.length == 1;
                    }
                  }
                ],
                methods: {
                  add() {
                    let button = {
                      currency_id: undefined,
                      rate_to_usd: 1
                    };
                    this.getModal("rate").list.unshift(button);
                  },
                  delete({ rowIndex }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.getModal("rate").list.splice(rowIndex, 1);
                      }
                    });
                  }
                }
              },
              {
                name: () => this.$t("currencyName"),
                align: "center",
                key: "currency_id",
                slot: "TEST",
                placeholder() {
                  return this.$t("select") + this.$t("currencyName");
                },
                bind: {
                  style: {
                    width: "100%"
                  }
                }
              },
              {
                name: () => "TO USD",
                align: "center",
                key: "rate_to_usd",
                placeholder() {
                  return this.$t("select") + "TO USD";
                },
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%"
                  },
                  // step: 0.000001,
                  min: 0
                }
              },
              {
                name: () => "TO AED",
                align: "center",
                key: "rate_to_aed",
                placeholder() {
                  return this.$t("select") + "TO AED";
                },
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%"
                  },
                  // step: 0.000001,
                  min: 0
                }
              },
              {
                name: () => "TO SER",
                align: "center",
                key: "rate_to_sar",
                placeholder() {
                  return this.$t("select") + "TO SER";
                },
                component: "InputNumber",
                bind: {
                  style: {
                    width: "100%"
                  },
                  // step: 0.000001,
                  min: 0
                }
              }
            ]
          }
        }
      },
      header: {
        searchs: [
          // {
          //   key: "code",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("currencyName");
          //   },
          //   clearable: true,
          //   options: [],
          //   config: { label: "code", value: "code" },
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "remote_regions",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("remote_regions");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('YES'), value: 1 },
          //     { label: this.$t('NO'), value: 0 }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          // {
          //   key: "status",
          //   component: "Select",
          //   placeholder() {
          //     return this.$t("select") + this.$t("exlType");
          //   },
          //   clearable: true,
          //   options: [
          //     { label: this.$t('enable'), value: "ENABLE" },
          //     { label: this.$t('disable'), value: "DISABLE" }
          //   ],
          //   bind: {
          //     style: "width:150px"
          //   }
          // },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
            // bind: {
            //   type: "textarea",
            //   autosize: { minRows: 2, maxRows: 2 }
            // }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: 448
            }
            // {
            //   name: () => this.$t("export"),
            //   type: "export",
            //   fnName: "export",
            //   disabled() {
            //     return !this.selectAll.length;
            //   },
            //   bind: {
            //     icon: "md-arrow-down",
            //     type: "primary"
            //   }
            // }
          ],
          methods: {
            // export() {
            //   this.exportExc();
            // },
            add() {
              this.getModal("add").open(null, () => {
                this.getModal("add").setTitle(this.$t("add"));
                this.getModal("add").type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("planName"),
          key: "name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("order_desc"),
          key: "remarks",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("operate"),
          key: "operator_name",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 100
        },
        {
          name: () => this.$t("upTime"),
          key: "update_time",
          align: "center",
          minWidth: 100
        },
        {
          type: "btns",
          width: 240,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              },
              id: 449
            },
            {
              name: this.$t("rate"),
              type: "rate",
              fnName: "rateFun",
              bind: {
                type: "warning"
              }
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete",
              bind: {
                type: "error"
              },
              id: 450
            }
          ],
          methods: {
            update({ row }) {
              this.handleRequestMethods("getDetails", row.id).then(res => {
                this.getModal("add").setTitle(this.$t("update"));
                this.getModal("add").type = "update";
                this.getModal("add").open(res.payload);
              });
            },
            rateFun({ row }) {
              this.handleRequestMethods("getRateDetails", { id: row.id }).then(
                res => {
                  this.getModal("rate").setTitle(this.$t("rate"));
                  this.getModal("rate").open({ id: row.id }, async function() {
                    that.options = (await getCurrency()).data.payload;
                    that.options.forEach(ele => {
                      res.payload.forEach(el => {
                        if (el.currency_id == ele.id) {
                          ele.disabled = true;
                        }
                      });
                    });
                    if (res.payload.length) {
                      this.list = res.payload;
                    } else {
                      this.list = [
                        {
                          currency_id: undefined,
                          rate_to_usd: 1
                        }
                      ];
                    }
                  });
                }
              );
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id, true).then(res => {
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  methods: {
    SelChange(val) {
      let list = this.$refs["table"].getModal("rate").list;
      this.options.forEach(el => {
        el.disabled = false;
        list.forEach(ele => {
          if (el.id == ele.currency_id) {
            el.disabled = true;
          }
        });
      });
    }
  }
};
</script>
